import React from 'react';

const TableSortUpIcon = () => (
    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.625 3.49125L2.625 14L4.375 14L4.375 3.49125H7L3.5 0L0 3.49125H2.625Z"
            fill="#EBB02D"
        />
    </svg>
);

export { TableSortUpIcon };
